import { Link } from 'react-router-dom';
import cleanworkLogo from '@/assets/images/cleanwork-logo.png';

const Footer = () => {
  return (
    <footer className="bg-[#0A2540] text-white">
      {/* Sección principal con grid */}
      <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
          {/* Columna 1: Logo y descripción */}
          <div className="lg:col-span-1">
            <img
              src={cleanworkLogo}
              alt="Clean Work Servicios de Limpieza"
              className="h-14 w-auto object-contain brightness-0 invert"
            />
            <p className="mt-4 max-w-xs text-sm text-blue-300 leading-relaxed">
              Soluciones profesionales de limpieza para empresas que cuidan su
              imagen.
            </p>
          </div>

          {/* Columna 2: Enlaces rápidos */}
          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider text-[#94cf1c]">
              Navegación
            </h4>
            <ul className="mt-4 space-y-3">
              {[
                ['Inicio', '#inicio'],
                ['¿Quiénes somos?', '#nosotros'],
                ['Servicios', '#servicios'],
                ['Proceso', '#proceso'],
              ].map(([label, href]) => (
                <li key={label}>
                  <a
                    href={href}
                    className="text-sm text-blue-300 hover:text-[#94cf1c] transition-colors"
                  >
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Columna 3: Servicios */}
          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider text-[#94cf1c]">
              Servicios
            </h4>
            <ul className="mt-4 space-y-3">
              {[
                'Limpieza de oficinas',
                'Limpieza de edificios',
                'Fraccionamientos',
                'Áreas públicas',
              ].map((service) => (
                <li key={service}>
                  <a
                    href="#servicios"
                    className="text-sm text-blue-300 hover:text-[#94cf1c] transition-colors"
                  >
                    {service}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Columna 4: Contacto */}
          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider text-[#94cf1c]">
              Contacto
            </h4>
            <ul className="mt-4 space-y-4 text-sm text-blue-300">
              {/* Oficina Central */}
              <li>
                <span className="block text-xs font-bold uppercase tracking-wider text-blue-400">
                  Oficina Central
                </span>
                <p className="mt-1 leading-relaxed">
                  Norte 3 núm. 24 - A Nuevo Parque Industrial,
                  <br />
                  San Juan del Río, Qro. CP 76806
                </p>
              </li>

              {/* Teléfono */}
              <li>
                <span className="block text-xs font-bold uppercase tracking-wider text-blue-400">
                  Teléfono
                </span>
                <a
                  href="tel:+524271107773"
                  className="block hover:text-[#94cf1c] transition-colors"
                >
                  (427) 110 7773
                </a>
              </li>

              {/* Email */}
              <li>
                <span className="block text-xs font-bold uppercase tracking-wider text-blue-400">
                  Email
                </span>
                <a
                  href="mailto:aydnieto@gmail.com"
                  className="hover:text-[#94cf1c] transition-colors"
                >
                  aydnieto@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Copyright con enlaces legales */}
      <div className="border-t border-[#94cf1c]/20 bg-[#061a2c]">
        <div className="mx-auto max-w-7xl px-5 py-6 lg:px-8">
          <div className="flex flex-col items-center justify-between gap-4 text-center text-xs text-blue-400 md:flex-row">
            <p>
              © {new Date().getFullYear()} CLEAN WORK. Todos los derechos
              reservados.
            </p>
            <div className="flex gap-6">
              <Link
                to="/privacidad"
                className="hover:text-[#94cf1c] transition-colors"
              >
                Aviso de privacidad
              </Link>
              <Link
                to="/terminos"
                className="hover:text-[#94cf1c] transition-colors"
              >
                Términos y condiciones
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;